import type { ScreenUnitInput } from '@his/shared';

export type ScreenMarker = 'hiv' | 'hepatitisB' | 'hepatitisC' | 'syphilis' | 'malaria';
export type ScreenAnswers = Record<ScreenMarker, boolean | null>;

export const SCREEN_MARKERS: ScreenMarker[] = ['hiv', 'hepatitisB', 'hepatitisC', 'syphilis', 'malaria'];
export const UNANSWERED_SCREEN: ScreenAnswers = { hiv: null, hepatitisB: null, hepatitisC: null, syphilis: null, malaria: null };

export function unansweredMarkers(answers: ScreenAnswers): ScreenMarker[] {
  return SCREEN_MARKERS.filter((marker) => answers[marker] === null);
}

export function completeScreen(answers: ScreenAnswers): ScreenUnitInput | null {
  if (unansweredMarkers(answers).length > 0) return null;
  return {
    hiv: answers.hiv === true,
    hepatitisB: answers.hepatitisB === true,
    hepatitisC: answers.hepatitisC === true,
    syphilis: answers.syphilis === true,
    malaria: answers.malaria === true,
  };
}
